// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"dd45469f","387":"f798436b","496":"caebea78","524":"231bb940","649":"1f8bf272","722":"d945880c","763":"4ec8b5bf","939":"13a00e8f","961":"bd6942e8","990":"82408cab"}[chunkId] + ".chunk.js";
};